import { render, staticRenderFns } from "./MemberDetailView.vue?vue&type=template&id=79c52590&scoped=true"
import script from "./MemberDetailView.vue?vue&type=script&lang=js"
export * from "./MemberDetailView.vue?vue&type=script&lang=js"
import style0 from "./MemberDetailView.vue?vue&type=style&index=0&id=79c52590&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c52590",
  null
  
)

export default component.exports